import type { LovDrDTO } from "@/features/api/extranet/dto/Demande/DR/LovDrDTO";
import { buildDemandeStore } from '@/features/interface/demande/shared';
import { drDemandeService, drDossierService } from "@/features/services/demande";
import {
  getNaturesFichiersDR as getNaturesFichiers,
  propertyStatusConfiguration,
  reglesConfiguration,
} from '@/features/domaine/regles-akto/DR'

export const useDemandeDRStore = buildDemandeStore<'MODEL_DR', LovDrDTO>({
  model: 'MODEL_DR',
  typeDemande: 'Remboursement',
  module: 'demande',
  demandeService: drDemandeService,
  propertyStatusConfiguration: propertyStatusConfiguration,
  reglesConfiguration: reglesConfiguration,
  getNaturesFichiers,
})

export const useDossierDRStore = buildDemandeStore<'MODEL_DR', LovDrDTO>({
  model: 'MODEL_DR',
  typeDemande: 'Remboursement',
  module: 'dossier',
  demandeService: drDossierService,
  propertyStatusConfiguration: {},
  reglesConfiguration: {},
  getNaturesFichiers
})
